var React = require('react');

function Cross2Inline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M31 31L23.9611 23.9611L17 17","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M31 17L24 24L17 31","strokeWidth":"2","strokeLinecap":"round","key":1})]);
}

Cross2Inline.defaultProps = {"viewBox":"0 0 48 48","fill":"none"};

module.exports = Cross2Inline;

Cross2Inline.default = Cross2Inline;
